export default function ConsiliulElevilorPagePage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        Calendarul alegerilor
        {/* <div className="flex justify-center">
          <iframe
            src="/educatie/consiliulElevilor/"
            title="Calendarul alegerilor"
            className="w-full h-[90vh] border-0"
          ></iframe>
        </div> */}
      </main>
    </div>
  );
}
